import { TelemetryService } from './telemetry.service';

export class NoOpTelemetryService implements TelemetryService {
  reportError(_: Error | string): void {
  }
}
